// extracted by mini-css-extract-plugin
export default {"btn":"Btn_btn__GsEOl","btn_grey":"Btn_btn_grey__C6mFl","btn_white":"Btn_btn_white__UDyop","btn_green":"Btn_btn_green__M9y+8"};